import DIApi from './_diApi';

class BudgetSourcePropertyAPI extends DIApi {
  controllerName = 'BudgetSourcePropertys';
}

export default new BudgetSourcePropertyAPI();
